module.exports = __webpack_public_path__ + "static/scale-model-of-indianapolis-indiana-fef6210f0e76f5011e9a434c97a73040.png";